module.exports = {"title":"Week 4: It Runs!","body":"<p>We continued working on running the code we were given this week.  Due to missing files, functions, and libraries, we were not able to make fast progress.  We made a second trip down to SIO to meet with Ana again.  We informed her of the missing files and functions, and she gave us access to some of the materials we still needed.  After the meeting, and a couple of email exchanges we were able to get the majority of the code in a working state.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-4/index.md
// module id = 495
// module chunks = 0